import { useEffect, useRef } from "react";
// import FlotteFilters from "./FlotteFilters";
import FlotteTable from "./FlotteTable/FlotteTable";
import useFlotte from "../hooks/useFlotte";
import { useAtom } from "jotai";
import { flotteFiltersAtom, flottePageAtom } from "../hooks/useFlotte";
import useStore from "../../../../context/useStore";
import useFlotteUrlSync from "../hooks/useFlotteUrlSync";

const FlotteList = () => {
  const [state] = useStore();
  console.log("state", state);
  const { actions } = useFlotte();
  const hasInitialized = useRef(false);
  const [flotteFilters] = useAtom(flotteFiltersAtom);
  const [flottePage] = useAtom(flottePageAtom);
  const { initialize } = useFlotteUrlSync();

  // Chargement initial des données
  useEffect(() => {
    // Ne charger qu'une seule fois
    if (!hasInitialized.current) {
      console.log("Chargement initial de la flotte...");
      const initResult = initialize();
      const filters = initResult?.filters && Object.keys(initResult.filters).length > 0
        ? initResult.filters
        : flotteFilters;
      actions.onLoadFlotteList(filters, flottePage);
      hasInitialized.current = true;
    }
  }, [actions]);

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <FlotteTable />
        </div>
      </div>
    </div>
  );
};

export default FlotteList;
